import React, { useContext, useEffect, useMemo, useState } from 'react';
import ReactTable from '../../components/ReactTable/ReactTable.jsx';
import { Link } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
import { config } from '../../config.js';
import { SidebarContext } from '../../context/SidebarContext';
import SectionMenuLeft from '../../components/SectionMenuLeft/SectionMenuLeft.jsx';
function Offer() {
	const [users, setUsers] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [loading, setLoading] = useState(true); // Loading state
	const { isSidebar } = useContext(SidebarContext);

	const getUsers = async () => {
		setLoading(true);
		try {
			const response = await fetch(`${config?.backEndBaseUrl}user/get`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'x-dashboard-request': 'true'  // custom header
				},
			});


			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const result = await response.json();
			if (result.status && Array.isArray(result.users)) {
				setUsers(result.users);
				setFilteredUsers(result.users);
			} else {
				setUsers([]);
				setFilteredUsers([]);
			}
		} catch (error) {
			console.error('Fetching users failed:', error);
			setUsers([]);
			setFilteredUsers([]);
		} finally {
			setLoading(false); // Stop loading
		}
	};

	useEffect(() => {
		getUsers();
	}, []);

	const columns = useMemo(
		() => [
			{ accessorKey: 'userName', header: 'Name' },
			{
				accessorKey: 'uid',
				header: 'Photo',
				cell: ({ cell }) => {
					const url = cell.row.original.photoURL;
					return (

						<Link to={url} >
							<img alt=''
								style={{ "height": "100px", "cursor": "pointer" }}
								src={url}
							/>
						</Link>
					);
				}
			},
			{ accessorKey: 'phoneNumber', header: 'Number' },
			{ accessorKey: 'email', header: 'Email' },

		],
		[]
	);



	return (
		<div className="body">
			<div id="wrapper">
				<div id="page" className="">
					<div className="layout-wrap">
						<SectionMenuLeft />
						<div className="section-content-right">
							<div className="main-content" style={{ paddingLeft: isSidebar ? '280px' : '0px' }}>
								<div className="main-content-inner">
									<div className="main-content-wrap">
										<div className="tf-section">
											<div className="wg-box" style={{ marginBottom: '20px' }}>
												<div className="flex items-center justify-between">
													<h5>Offers Overview</h5>
												</div>

												{/* Show spinner while loading */}
												{loading ? (
													<div className="loading-spinner" style={{ textAlign: 'center', padding: '20px' }}>
														<div className="spinner-border text-primary" role="status">
															<span className="sr-only">Loading...</span>
														</div>
													</div>
												) : (
													<>
														<ReactTable columns={columns} data={filteredUsers} />
													</>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


	);
}

export default Offer;



